module.exports = __webpack_public_path__ + "static/media/buttonImage.0dba884e.png";